import {
    useMemo,
} from 'react'

import StatusHandler from 'app/shared-components/StatusHandler'

import {
    ArchiveButton, ArchiveConfirmationDialog, useArchive,
} from 'app/shared-components/Archive'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import useContainerManagementRoutes from 'app/SkyNetRoutes/hooks/useContainerManagementRoutes'
import requests from 'app/requests/ServiceCenter/ServiceCenter.requests'
import useGetServiceCenterById from '../hooks/useGetServiceCenterById'
import ServiceCenterForm from '../ServiceCenterForm'

const ServiceCenterUpdate = ({
    id,
}: { id: number }) => {
    const {
        ServiceCenters: ServiceCentersRoutes,
    } = useContainerManagementRoutes()
    const {
        data,
        isDataReady,
        isError,
        error,
        isFetching,
        invalidate,
    } = useGetServiceCenterById(id)

    const archive = useArchive({
        requestParamFn: data?.archived ? requests.restore
            : requests.archive,
        notificationId: 'ServiceCenter',
        title: 'Service Center',
        data,
        redirectionAfterSuccess: generateSkyNetLink({
            domainPath: ServiceCentersRoutes.Overview.path,
            params: {
                key: id,
            },
        }),
        onSuccess: invalidate,
    })

    const customButtons = useMemo(() => {
        return [<ArchiveButton
            onClick={archive.handleArchiveRestore}
            archived={data?.archived}
        />]
    }, [
        data,
        archive.handleArchiveRestore,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady && Boolean(data)}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <>
                <ServiceCenterForm
                    data={data}
                    customButtons={customButtons}
                    exists
                    requestParam={requests.update({
                        serviceCenterId: data?.id,
                    })}
                    onSuccess={invalidate}
                />
                <ArchiveConfirmationDialog
                    title="Service Center"
                    openConfirmDialog={archive.openConfirmDialog}
                    handleClose={archive.handleArchiveRestoreConfirm}
                    archived={data?.archived}
                />
            </>
        </StatusHandler>
    )
}

export default ServiceCenterUpdate
